import { ColorEnum } from '@/constants/color'
import { knobRadius, knobSize } from '@/features/ui/inputs/components/Switch/constants'
import { FC } from 'react'
import Svg, { Circle, SvgProps } from 'react-native-svg'

const CircleIcon: FC<SvgProps> = ({ fill = ColorEnum.WHITE, ...props }) => {
    const { width, height } = knobSize

    return (
        <Svg
            fill="none"
            viewBox={`0 0 ${width} ${height}`}
            width={width}
            height={height}
            {...props}
        >
            <Circle cx={width / 2} cy={height / 2} r={knobRadius} fill={fill} />
        </Svg>
    )
}

export default CircleIcon
